<div class="row">
  <div class="middle-container">
    <div class="detail-breadcrumb">
      <span> <a href="javascript:void(0)" (click)="redirectToLanding()">Quote</a> <span class="xs-ml-10 xs-mr-10">></span> {{quoteNumber}}</span>
    </div>
    <div class="tableContainer dealertableContainer">
      <table mat-table [dataSource]="quoteDetail" multiTemplateDataRows class="matTables">
        <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedHeaderTableCol">
          <div *ngIf="column=='account'"><th mat-header-cell *matHeaderCellDef class="">Account Name</th>
    </div>
    <div *ngIf="column=='status'"><th mat-header-cell *matHeaderCellDef class="text-center">Status</th></div>
    <div *ngIf="column=='quoteDate'"><th mat-header-cell *matHeaderCellDef class="text-center">Quote Date</th></div>
    <div *ngIf="column=='closeDate'"><th mat-header-cell *matHeaderCellDef class="text-center">Close Date</th></div>
    <div *ngIf="column=='preparedBy'"><th mat-header-cell *matHeaderCellDef class="text-center">Prepared By</th></div>
    <div *ngIf="column=='preparedFor'"><th mat-header-cell *matHeaderCellDef class="text-center">Prepared For</th></div>
    <div *ngIf="column=='approvedBy'"><th mat-header-cell *matHeaderCellDef class="text-center">Approved By</th></div>
    <div *ngIf="column=='approvalDate'"><th mat-header-cell *matHeaderCellDef class="text-center">ApprovalDate</th></div>
    <div *ngIf="column=='detail'"><th mat-header-cell *matHeaderCellDef class="viewProdDetails">&nbsp;</th></div>

    <td mat-cell *matCellDef="let element">
      <div *ngIf="column=='account'">
        <div class="order-info defaultCursor margin-l0">
          <p> <span>{{element.accountName}}</span> </p>
          <p class="grower-name">{{element.address}}, {{element.city}}, {{element.state}} {{element.zipCode}}</p>
        </div>
      </div>
      <div *ngIf="column=='status'" class="text-center largeTableTxt">
        <ng-container> {{element.status}}</ng-container>
      </div>
      <div *ngIf="column=='quoteDate'" class="text-center largeTableTxt">
        <ng-container> {{element.quoteDate  | date:'MM/dd/yyyy'}}</ng-container>
      </div>
      <div *ngIf="column=='closeDate'" class="text-center largeTableTxt">
        <ng-container> {{element.closeDate | date:'MM/dd/yyyy'}}</ng-container>
      </div>
      <div *ngIf="column=='preparedBy'" class="text-center largeTableTxt">{{element.preparedBy}}</div>
      <div *ngIf="column=='preparedFor'" class="text-center largeTableTxt">
        <ng-container> {{element.preparedFor }}</ng-container>
      </div>
      <div *ngIf="column=='approvedBy'" class="text-center largeTableTxt">{{element.approvedBy}}</div>
      <div *ngIf="column=='approvalDate'" class="text-center largeTableTxt">
        <ng-container> {{element.approvalDate | date:'MM/dd/yyyy' }}</ng-container>
      </div>
      <div *ngIf="column=='detail' && quoteDetail[0].comments != null && quoteDetail[0].comments!=''" class="viewProdDetailsData link-bold">
        <ng-container>
          <a (click)="showComments(element);">{{element.isDetailDisplayed ? 'Hide Comments':'View Comments' }}</a>
        </ng-container>
        <ng-template #elseBlock>
          <ng-container class="text-center productDetailsFont">View Comments</ng-container>
        </ng-template>
      </div>
    </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
        <div [style.display]="element.isDetailDisplayed ? 'block' : 'none'">
          <div class="cpp-prod-info">
            <table style="width:100%">
              <tbody>
                <tr>
                  <th width="100%" class="text-left">Comments </th>
                </tr>
                <tr>
                  <td width="100%" class="text-left">
                    <textarea type="text" maxlength="" readonly [(ngModel)]="quoteDetail[0].comments" rows="3" class="common-textarea" placeholder="*A reason for approving with exceptions or rejecting the quote must be entered."></textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedHeaderTableCol;sticky:true;"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedHeaderTableCol;"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" [style.display]="row.isDetailDisplayed ? 'table-row' : 'none'"></tr>
    </table>
    <div class="table-scroll" [ngClass]="{'active': expendedVar}">
      <table mat-table [dataSource]="quoteItemList" multiTemplateDataRows class="matTables">
        <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
          <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="xs-pl-60">Product</th>
    </div>
    <div *ngIf="column=='detail'"><th mat-header-cell *matHeaderCellDef class="viewProdDetails">&nbsp;</th></div>
    <div *ngIf="column=='quoteQty'"><th mat-header-cell *matHeaderCellDef class="text-center">Quote Qty</th></div>
    <div *ngIf="column=='releaseQty'"><th mat-header-cell *matHeaderCellDef class="text-center">Release Qty</th></div>
    <div *ngIf="column=='remainingQty'"><th mat-header-cell *matHeaderCellDef class="text-center">Remaining Qty</th></div>
    <div *ngIf="column=='orderUOM'"><th mat-header-cell *matHeaderCellDef class="text-center">Order UOM</th></div>
    <div *ngIf="column=='unitPrice'"><th mat-header-cell *matHeaderCellDef class="text-center">Unit Price</th></div>
    <div *ngIf="column=='priceUOM'"><th mat-header-cell *matHeaderCellDef class="text-center">Price UOM</th></div>
    <div *ngIf="column=='qtyInPriceUOM'"><th mat-header-cell *matHeaderCellDef class="text-center">Qty in Price UOM</th></div>
    <div *ngIf="column=='paymentTerms'"><th mat-header-cell *matHeaderCellDef class="text-center">Payment Terms</th></div>
    <div *ngIf="column=='requestedDeliveryDate'"><th mat-header-cell *matHeaderCellDef class="text-center">Requested Arrival Date</th></div>

    <td mat-cell *matCellDef="let element">
      <div *ngIf="column=='product'">
        <div class="order-info defaultCursor margin-l0 xs-pl-35">
          <p> <span>{{element.vendorName}}</span> </p>
          <p class="grower-name">{{element.itemDescription}}</p>
          <p><span *ngIf="plAccess==true && element.yourPrice!='' && element.yourPrice!=null && element.yourPrice!=0" class="growerUnit">${{element.yourPrice | number:'1.4-4'}}/{{element.priceUOM}}</span></p>
          <!--<p> <span class="paymentTerm" *ngIf="plAccess==true && element.paymentTermDescription!='' && element.paymentTermDescription!=null && element.paymentTermDescription!=undefined">{{element.paymentTermDescription }}</span></p>-->
        </div>
      </div>
      <div *ngIf="column=='detail'" class="viewProdDetailsData link-bold">
        <ng-container>
          <a (click)="showProductDetails(element);">{{element.isDetailDisplayed ? 'Hide Product Details':'View Product Details' }}</a>
        </ng-container>
        <ng-template #elseBlock>
          <ng-container class="text-center productDetailsFont">View Product Details</ng-container>
        </ng-template>
      </div>
      <div *ngIf="column=='quoteQty'" class="text-center largeTableTxt">
        <ng-container> {{element.quoteQty | number:'1.4-4'}}</ng-container>
      </div>
      <div *ngIf="column=='releaseQty'" class="text-center largeTableTxt">
        <ng-container> {{element.releaseQty | number:'1.4-4'}}</ng-container>
      </div>
      <div *ngIf="column=='remainingQty'" class="text-center largeTableTxt">
        <ng-container> {{element.quoteQty - element.releaseQty | number:'1.4-4'}}</ng-container>
      </div>
      <div *ngIf="column=='orderUOM'" class="text-center largeTableTxt">{{element.orderUOM}}</div>
      <div *ngIf="column=='unitPrice'" class="text-center largeTableTxt">
        <ng-container> {{element.unitPrice | number:'1.4-4'}}</ng-container>
      </div>
      <div *ngIf="column=='priceUOM'" class="text-center largeTableTxt">{{element.priceUOM}}</div>
      <div *ngIf="column=='qtyInPriceUOM'" class="text-center largeTableTxt">
        <ng-container> {{element.qtyInPriceUOM | number:'1.4-4'}}</ng-container>
      </div>
      <div *ngIf="column=='paymentTerms'" class="text-center largeTableTxt">{{element.paymentTerms}}</div>
      <div *ngIf="column=='requestedDeliveryDate'" class="text-center largeTableTxt">{{element.requestedDeliveryDate | date:'MM/dd/yyyy'}}</div>
    </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
        <div [style.display]="element.isDetailDisplayed ? 'block' : 'none'">
          <div class="cpp-prod-info">
            <table style="width:100%">
              <tbody>
                <tr>
                  <th width="15%" class="text-left">Item # </th>
                  <th width="17%"> GTIN </th>
                  <th width="17%"> Product Line </th>
                  <th width="17%"> Active Ingredients </th>
                  <!--<th width="14%"> National Price </th>-->
                  <th width="17%"> Pallet Quantity </th>
                  <th width="17%"> Restricted Use </th>
                </tr>
                <tr>
                  <td width="15%" class="text-left"><p>{{element.itemNumber}}</p> </td>
                  <td width="17%"><p>{{element.gtin}}</p></td>
                  <td width="17%"><p>{{element.productLine}}</p> </td>
                  <td width="17%"><p>{{element.activeIngredient}}</p> </td>
                  <!--<td width="14%"><p>{{element.nationalPrice | number:'1.4-4'}}</p> </td>-->
                  <td width="17%"><p>{{element.palletQuantity | number:'1.4-4'}}</p> </td>
                  <td width="17%"><p>{{element.restrictedUse}}</p> </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="errorDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
        <div class="inline-error" *ngIf="element.lineLevelError.length > 0" [style.display]="element.hasError ? 'block' : 'none'">
          <div class="row">
            <div class="col-md-12">
              <ol class="error-list">
                <li *ngFor="let err of element.lineLevelError">
                  {{err}}
              </ol>
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" [style.display]="row.isDetailDisplayed ? 'table-row' : 'none'"></tr>
    <tr mat-row *matRowDef="let row; columns: ['errorDetail']" class="example-detail-row" [style.display]="row.hasError ? 'table-row' : 'none'"></tr>
    </table>
  </div>
  <div class="noDataMsg noDataBg" *ngIf="quoteItemList == undefined || quoteItemList?.length == 0">
    <p>No Record Found.</p>
  </div>
</div>
  </div>

<div class="footer-action">
  <div class="row">
    <div *ngIf="(isQuoteExpire && quoteStatus == 'OPEN') else quoteActive" class="col-md-11 ml-auto mr-auto d-flex">
      <span class="erp-order">* This quote closed on {{quoteDetail[0].closeDate | date:'MM/dd/yyyy'}}. No actions can be taken.</span>
    </div>
    <ng-template #quoteActive>
      <div class="col-md-11 ml-auto mr-auto d-flex">
        <div class="flex-one">
          <button *ngIf="isQuoteApproveAccess" mat-raised-button class="btns xs-ml-15" color="primary" [style.display]="'inline-block'" [disabled]="!isApproveRejectAccess" (click)="isApproveRejectAccess && approveOrRejectQuote()">Approve/Reject Quote</button>
          <button *ngIf="isCloseQuoteAccess" [disabled]="!isQuoteClosed" mat-raised-button class="btns xs-ml-15" color="primary" [style.display]="'inline-block'" (click)="isCloseQuoteAccess && closeQuote()">Close Quote</button>
        </div>
        <button mat-raised-button class="btns xs-ml-15" color="primary" [style.display]="'inline-block'" [disabled]="!isCreateSalesOrderAccess" (click)="isCreateSalesOrderAccess && createQuoteOrder()">Create Sales Order</button>
        <button mat-raised-button class="btns xs-ml-15" color="primary" [style.display]="'inline-block'" [disabled]="!isReviewSalesOrderAccess" (click)="isReviewSalesOrderAccess && reviewSalesOrder()">Review Sales Order</button>
        <button mat-raised-button class="btns xs-ml-15" color="primary" [style.display]="'inline-block'" [disabled]="!isSubmitToFulfillmentAccess || !hasNoRemainingQty" (click)="(isSubmitToFulfillmentAccess || hasNoRemainingQty) && submitSalesOrder()">Submit Sales Order(s) for Fulfillment</button>
      </div>
    </ng-template>
  </div>
</div>
</div>
